import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface NavigationState {
  isMenuExpanded: boolean;
  toggleMenu: () => void;
  setMenuExpanded: (expanded: boolean) => void;
}

export const useNavigationStore = create<NavigationState>()(
  persist(
    (set) => ({
      isMenuExpanded: true,
      toggleMenu: () => set((state) => ({ isMenuExpanded: !state.isMenuExpanded })),
      setMenuExpanded: (expanded) => set({ isMenuExpanded: expanded })
    }),
    {
      name: 'navigation-state'
    }
  )
);